import {RESERVATION_CONFIRMED} from "../../app/constants/storage_keys";
import {RESERVED_MARKER_TTL_MIN} from "../constants/reservation_constants";
import {createTimedRecordStorage} from "./create_timed_record_storage";

// Persistence of the "reserved by me" slice only - never read during render, the slice is hydrated after mount

export const getReservedMarkerExpiresAt = (now: number) => now + RESERVED_MARKER_TTL_MIN * 60 * 1000;

// propertyId -> expiresAt (epoch ms), without expired entries
const markerStorage = createTimedRecordStorage<number>({
    key: RESERVATION_CONFIRMED,
    ttlMin: RESERVED_MARKER_TTL_MIN,
    readEntry: (expiresAt, now) => (typeof expiresAt === "number" && expiresAt > now ? expiresAt : null)
});

export const readReservedMarkers = (now: number = Date.now()): Record<string, number> => markerStorage.read(now);

export const writeReservedMarker = (propertyId: number, expiresAt: number, now: number = Date.now()) => {
    markerStorage.update(propertyId, now, () => expiresAt);
};

export const clearReservedMarkers = markerStorage.clear;
import {RESERVATION_CONFIRMED} from "../../app/constants/storage_keys";
import {RESERVED_MARKER_TTL_MIN} from "../constants/reservation_constants";
import {createTimedRecordStorage} from "./create_timed_record_storage";

// Persistence of the "reserved by me" slice only - never read during render, the slice is hydrated after mount

export const getReservedMarkerExpiresAt = (now: number) => now + RESERVED_MARKER_TTL_MIN * 60 * 1000;

// propertyId -> expiresAt (epoch ms), without expired entries
const markerStorage = createTimedRecordStorage<number>({
    key: RESERVATION_CONFIRMED,
    ttlMin: RESERVED_MARKER_TTL_MIN,
    readEntry: (expiresAt, now) => (typeof expiresAt === "number" && expiresAt > now ? expiresAt : null)
});

export const readReservedMarkers = (now: number = Date.now()): Record<string, number> => markerStorage.read(now);

export const writeReservedMarker = (propertyId: number, expiresAt: number, now: number = Date.now()) => {
    markerStorage.update(propertyId, now, () => expiresAt);
};

export const clearReservedMarkers = markerStorage.clear;
